<div [ngClass]="isInline ? 'd-inline-block': 'd-flex justify-content-center align-items-center'">
  <div class="loader" [style.--dot-size]="dotSize" [style.--loader-size]="loaderSize" [style.--dot-color]="dotColor">
  </div>
</div>
